
import utils from '@/components/pages/guests/mixins/utils'

export default {
    mixins: [utils],

    props: {
        guest: {
            type: Object,
            default: () => {
                return {}
            },
        },

        event: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    computed: {
        getMealOption() {
            const guestEvent = this.guest.wedding_events?.length ? this.guest.wedding_events.find((event) => event.id === this.event.id) : {}
            let selectedMealOption = null
            try {
                selectedMealOption = JSON.parse(guestEvent.selected_meal_options)
            } catch (error) {
                selectedMealOption = guestEvent.selected_meal_options?.length || null
            }
            return selectedMealOption ? selectedMealOption[0] : null
        },

        isAttending() {
            const guestEvent = this.guest.wedding_events?.length ? this.guest.wedding_events.find((event) => event.id === this.event.id) : {}
            return guestEvent.status === 3
        },
    },
}
